import { render, staticRenderFns } from "./CbsGroupby.vue?vue&type=template&id=5315d18b&scoped=true"
import script from "./CbsGroupby.vue?vue&type=script&lang=js"
export * from "./CbsGroupby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5315d18b",
  null
  
)

export default component.exports